/* ============================================================
   FAQ SECTION  —  assets/faq.js
   - Single-open accordion (open one closes the rest), driven by
     the `.is-open` class + CSS grid-rows animation.
   - Smooth scroll for category jump-links.
   - Scroll-spy: highlights the nav link of the group in view.
   - Full Shopify theme-editor support (section/block select).
   ============================================================ */
(function () {
  var HEADER_OFFSET = 120;

  function closeAll(section) {
    section.querySelectorAll('.faq-section__item').forEach(function (item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('.faq-section__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openItem(section, item) {
    closeAll(section);
    item.classList.add('is-open');
    var trigger = item.querySelector('.faq-section__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function initSection(section) {
    if (!section || section.dataset.faqInit === 'true') return;
    section.dataset.faqInit = 'true';

    /* --- Accordion toggles --- */
    section.querySelectorAll('.faq-section__item').forEach(function (item) {
      var trigger = item.querySelector('.faq-section__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        if (item.classList.contains('is-open')) {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          openItem(section, item);
        }
      });
    });

    /* --- Smooth-scroll jump-links --- */
    var navLinks = Array.prototype.slice.call(
      section.querySelectorAll('.faq-section__nav-link')
    );
    navLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var hash = link.getAttribute('href') || '';
        if (hash.charAt(0) !== '#') return;
        var target = section.querySelector(hash) || document.querySelector(hash);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', hash);
      });
    });

    /* --- Scroll-spy active state --- */
    var groups = Array.prototype.slice.call(
      section.querySelectorAll('.faq-section__group')
    );
    if (groups.length && navLinks.length && 'IntersectionObserver' in window) {
      var linkById = {};
      navLinks.forEach(function (link) {
        linkById[link.getAttribute('href')] = link;
      });
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            navLinks.forEach(function (link) {
              link.classList.remove('is-active');
            });
            var active = linkById['#' + entry.target.id];
            if (active) active.classList.add('is-active');
          });
        },
        { rootMargin: '-' + HEADER_OFFSET + 'px 0px -60% 0px', threshold: 0 }
      );
      groups.forEach(function (group) {
        observer.observe(group);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.faq-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* --- Theme editor --- */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.faq-section');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest && event.target.closest('.faq-section__item');
    var section = event.target.closest && event.target.closest('.faq-section');
    if (item && section) {
      openItem(section, item);
    } else {
      var group = event.target.closest && event.target.closest('.faq-section__group');
      if (group) group.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();
